// extracted by mini-css-extract-plugin
export var contentSection = "_8-8";
export var imageSection = "_8-1";
export var productGrid = "_8-0";
export var productImage = "_8-3";
export var productImageContainer = "_8-2";
export var productInfo = "_8-9";
export var purchaseControls = "_8-a";
export var quantityInput = "_8-c";
export var selectedThumbnail = "_8-6";
export var thumbnailContainer = "_8-4";
export var thumbnailImage = "_8-7";
export var thumbnailItem = "_8-5";
export var variantSelect = "_8-b";